module.exports = __webpack_public_path__ + "img/20220219_072552.496394f3.jpg";